import { useState, Link, useNavigate, useSearchParams, motion, axios, Button, Input, Card, CardContent, CardHeader, CardTitle, CardDescription, Label, Loader2, Check, X, LOGO_URL, API, toast } from "@/pages/shared";

export const ResetPasswordPage = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (password !== confirmPassword) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setSuccess(true);
      toast.success("Password reset successfully!");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to reset password. The link may have expired.");
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6 hero-glow">
        <Card className="glass w-full max-w-md">
          <CardContent className="p-8 text-center">
            <X className="w-12 h-12 text-violet-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold mb-2">Invalid Reset Link</h2>
            <p className="text-muted-foreground mb-4">This password reset link is invalid or has expired.</p>
            <Link to="/forgot-password"><Button className="rounded-full bg-violet-600 hover:bg-violet-700">Request New Link</Button></Link>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6 hero-glow">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 justify-center mb-8">
          <img src={LOGO_URL} alt="Creatara - Set New Password" className="w-12 h-12 rounded-xl" />
          <span className="text-2xl font-bold">Creatara</span>
        </Link>
        <Card className="glass">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl">{success ? "Password Reset!" : "Set New Password"}</CardTitle>
            <CardDescription>{success ? "You can now sign in with your new password" : "Enter your new password below"}</CardDescription>
          </CardHeader>
          <CardContent>
            {success ? (
              <div className="text-center space-y-4" data-testid="reset-password-success">
                <div className="w-16 h-16 rounded-full bg-teal-500/20 flex items-center justify-center mx-auto">
                  <Check className="w-8 h-8 text-teal-500" />
                </div>
                <Button onClick={() => navigate("/login")} className="rounded-full bg-violet-600 hover:bg-violet-700" data-testid="go-to-login-btn">Go to Login</Button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label>New Password</Label>
                  <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="mt-1 bg-white/5 border-white/10" required minLength={6} data-testid="new-password-input" />
                </div>
                <div>
                  <Label>Confirm Password</Label>
                  <Input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="••••••••" className="mt-1 bg-white/5 border-white/10" required minLength={6} data-testid="confirm-password-input" />
                </div>
                <Button type="submit" className="w-full btn-primary-glow bg-violet-600 hover:bg-violet-700 rounded-full" disabled={loading} data-testid="reset-submit-btn">
                  {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Reset Password"}
                </Button>
              </form>
            )}
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};
